import iFrameResize from 'iframe-resizer/js/iframeResizer'

iFrameResize({ log:true, scrolling:'auto', resizeFrom:'parent', bodyMargin:'20px 0' }, '#feature-slider-0 iframe')